import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';

import { applicationsCreateActions } from '../actions';
import { ApplicationsCreateState } from '../reducers/applications-create.reducer';
import { selectCreateLoading } from '../selectors';

@Injectable()
export class ApplicationsCreateFacade {
  private readonly store: Store<ApplicationsCreateState> = inject(Store);

  public create(containerId: string): void {
    this.store.dispatch(applicationsCreateActions.create({ containerId }));
  }

  public selectLoading(): Signal<boolean> {
    return this.store.selectSignal(selectCreateLoading);
  }
}
